import { forwardRef, ComponentProps, ForwardRefExoticComponent } from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import { withStyles } from '../../../utils';

import styles from './CardTabs.module.scss';

const classes = withStyles(styles);

type RootComponent = ForwardRefExoticComponent<ComponentProps<typeof Tabs.Root>>;

export const Root: RootComponent = forwardRef((props, ref) => {
  return (
    <Tabs.Root ref={ref} {...props} className={classes('cardTabsContainer', props.className)}>
      {props.children}
    </Tabs.Root>
  );
});

type ListComponent = ForwardRefExoticComponent<ComponentProps<typeof Tabs.List>>;

export const List: ListComponent = forwardRef((props, ref) => {
  return (
    <Tabs.List ref={ref} {...props} className={classes('tabList', props.className)}>
      {props.children}
    </Tabs.List>
  );
});

type TriggerComponent = ForwardRefExoticComponent<ComponentProps<typeof Tabs.Trigger>>;

export const Trigger: TriggerComponent = forwardRef((props, ref) => {
  return (
    <Tabs.Trigger
      ref={ref}
      {...props}
      className={classes('trigger', props.className)}
      style={{
        '--clipPath': `url(#${props.value})`,
      }}
    >
      {props.children}

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="0"
        height="0"
        style={{
          opacity: 0,
          position: 'fixed',
          top: '-1000%',
          left: '-1000%',
        }}
      >
        <defs>
          <clipPath id={props.value} clipPathUnits="objectBoundingBox">
            <path d="M 0 1 C 1 1 1 0.9 1 .062 L 1 1 Z" />
          </clipPath>
        </defs>
      </svg>
    </Tabs.Trigger>
  );
});

type ContentComponent = ForwardRefExoticComponent<ComponentProps<typeof Tabs.Content>>;

export const Content: ContentComponent = forwardRef((props, ref) => {
  return (
    <Tabs.Content ref={ref} {...props} className={classes('content', props.className)}>
      {props.children}
    </Tabs.Content>
  );
});
